module.exports = __webpack_public_path__ + "img/NP10.c60e9f5b.jpeg";